import React from 'react';

const JS_Errors = () => {
  return (
    <div >
      <h1>JS_Errors</h1>
      <p>Placeholder component for: "JS Errors"</p>
    </div>
  );
};

export default JS_Errors;
